import StatusBadge from "@/components/request-status/status-badge";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

interface HistoryItem { at: string; by?: { id: number | null; name?: string | null; full_name?: string | null; email?: string | null } | null; from?: string | null; to?: string | null }

interface StatusHistoryDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  currentStatus: string;
  history: HistoryItem[];
}

export default function StatusHistoryDialog({ open, onOpenChange, currentStatus, history }: StatusHistoryDialogProps) {
  const items = [...history].reverse(); // latest first
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle>Historial de estado</DialogTitle>
          <DialogDescription className="flex items-center gap-2">
            Actual: <StatusBadge status={currentStatus} />
          </DialogDescription>
        </DialogHeader>

        <div className="mt-2 space-y-3">
          {items.length === 0 ? (
            <div className="text-sm text-muted-foreground">Sin cambios registrados.</div>
          ) : (
            items.map((h, idx) => (
              <div key={idx} className="flex items-center justify-between gap-3 rounded-md border p-2">
                <div className="flex items-center gap-2">
                  {h.from ? <StatusBadge status={h.from} /> : <span className="text-xs text-muted-foreground">—</span>}
                  <span className="text-muted-foreground">→</span>
                  {h.to ? <StatusBadge status={h.to} /> : <span className="text-xs text-muted-foreground">—</span>}
                </div>
                <div className="text-right text-xs text-muted-foreground">
                  <div>{new Date(h.at).toLocaleString()}</div>
                  <div>{h.by?.full_name ?? h.by?.name ?? h.by?.email ?? "(usuario desconocido)"}</div>
                </div>
              </div>
            ))
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
